/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import request from '../axios';
var login = function (username, password) {
    var auth = {
        username: username,
        password: password,
    };
    return request({
        url: '/login',
        method: 'GET',
        auth: auth,
    });
};
export var AuthService = {
    login: login,
};
